import { useFormContext } from 'react-hook-form';
import { IGuestBookingFormData } from '../types/IGuestBookingFormData';

export function useGuestBookingFormContext() {
	return useFormContext<IGuestBookingFormData>();
}
